<template>
    <div class="tw-relative">
        <div ref="trigger">
            <slot :count="totalUnread" :open="open"></slot>
        </div>
        <div v-show="is_open" ref="menu" class="tw-bg-white tw-rounded tw-overflow-hidden tw-shadow" style="width : 20rem">
            <div class="tw-divide-y tw-divide-gray-100">
                <div class="tw-text-lg tw-font-bold tw-p-4">{{$word.latest_updated_chats}}:</div>
                <div v-if="loading" class="tw-p-10 tw-flex tw-items-center tw-justify-center">
                    <i class="bx bx-loader-alt bx-spin tw-text-3xl"></i>
                </div>
                <template v-else>
                    <div v-if="latestChats.length === 0" class="tw-py-16 tw-text-center tw-font-bold tw-text-gray-300">{{$word.no_new_messages}}</div>
                    <a
                        v-on:click="delayedRefresh"
                        :href="`/${$window.locale}/dashboard/my-chats?chat_id=${chat.id}`"
                        class="tw-p-4 tw-flex tw-items-center tw-space-x-4 hover:tw-bg-blue-50 hover:tw-text-blue-600"
                        v-for="chat in latestChats" :key="chat.id"
                    >
                        <img :src="chatImage(chat)" class="tw-w-8 tw-h-8 tw-rounded-full tw-object-cover" alt="">
                        <div class="tw-overflow-hidden">
                            <div class="tw-font-semibold">{{chatTitle(chat)}}</div>
                            <div class="tw-text-dark-3 tw-text-opacity-75 tw-truncate">{{chat.last_message}}</div>
                        </div>
                    </a>
                    <a :href="`/${$window.locale}/dashboard/my-chats`" class="tw-block tw-p-4 tw-text-center hover:tw-bg-blue-50 hover:tw-text-blue tw-font-bold">{{$word.show_all}}</a>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
    import {createPopper} from "@popperjs/core";

    export default {
        data: v => ({
            is_open: false,
            chats: [],
            totalUnread: 0,
            loading: false,
            last_update: 0,
            last_broadcast: 0,
            initialized: false,
        }),
        props: {
            user: {},
        },
        mounted() {
            Echo.private('users.' + this.user.id)
                .listen('ChatUpdated', e => {
                    this.refresh()
                })
                .listen('ChatViewed', e => {
                    this.refresh()
                })
        },
        created() {
            this.open = _.throttle(() => {
                this.needsRefresh && this.refresh()
                this.is_open = true
            }, 100)
            this.close = _.throttle(() => this.is_open = false, 100)

            this.refresh()

            let documentClickCallback = ev => {
                if (ev.target !== this.$el && !this.$el.contains(ev.target)) {
                    this.close()
                }
            }
            this.$on('hook:mounted', () => document.addEventListener('click', documentClickCallback))
            this.$on('hook:beforeDestroy', () => document.removeEventListener('click', documentClickCallback))
        },
        computed: {
            latestChats() {
                return _.chain(this.chats)
                    .slice(0, 4)
                    .value()
            },
            needsRefresh() {
                return this.initialized === false || this.last_update < this.last_broadcast
            },
        },
        methods: {
            otherUser(chat) {
                return chat.users.filter(user => user.id !== this.user.id)[0]
            },
            chatImage(chat) {
                return this.otherUser(chat).avatar
            },
            chatTitle(chat) {
                return this.otherUser(chat).name
            },
            delayedRefresh() {
                setTimeout(() => this.refresh(), 500)
            },
            refresh() {
                // todo throttle
                this.loading = true
                axios.get(`/api/v1/chat/unread`, {
                    params: {token: window.jwt_token},
                }).then(resp => {
                    console.log(resp.data.data)
                    this.chats = resp.data.data
                    this.totalUnread = resp.data.data.length
                }).finally(() => {
                    this.loading = false
                    this.initialized = true
                    this.last_update = Date.now()
                })
            }
        },
        watch: {
            is_open(value) {
                value && createPopper(this.$refs.trigger, this.$refs.menu, {
                    placement: "bottom"
                })
            }
        }
    }
</script>
